import { Component, EventEmitter, Output } from '@angular/core';
import { TileComponent } from '../../../../../../shared/src/lib/components/tile/tile.component';
import { FormsModule } from '@angular/forms';
import { TextareaComponent } from '../../../../../../shared/src/lib/components/textarea/textarea.component';
import { ButtonComponent } from '../../../../../../shared/src/lib/components/button/button.component';
import { Angulartics2OnModule } from 'angulartics2';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-add-alarm-comment-tile',
    templateUrl: './add-alarm-comment-tile.component.html',
    styleUrls: ['./add-alarm-comment-tile.component.scss'],
    imports: [TileComponent, FormsModule, TextareaComponent, ButtonComponent, Angulartics2OnModule, TranslateModule]
})
export class AddAlarmCommentTileComponent {
  @Output() commentSubmit = new EventEmitter<string>();

  public comment = '';

  onSubmit() {
    const trimmed = this.comment.trim();
    if (trimmed) {
      this.commentSubmit.emit(this.comment);
      this.comment = '';
    }
  }
}
